import React from "react";
import { motion } from "framer-motion";
import { FaGithub, FaLinkedin, FaXTwitter } from "react-icons/fa6";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="relative border-t border-black/5 dark:border-white/10 mt-16 overflow-hidden">
      <motion.div
        aria-hidden
        animate={{ x: [-40, 40, -40] }}
        transition={{ duration: 14, repeat: Infinity, ease: "easeInOut" }}
        className="pointer-events-none absolute -top-24 left-1/2 -translate-x-1/2 w-[520px] h-[220px] rounded-full blur-3xl opacity-30 dark:opacity-25"
        style={{
          background:
            "radial-gradient(circle, rgba(220,38,38,0.4), transparent 70%)",
        }}
      />

      <div className="relative w-[92%] lg:w-[82%] mx-auto pt-10 pb-6">
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8">
          <div className="flex-1 w-full">
            <p className="text-xs tracking-[0.2em] uppercase opacity-60 text-textClr dark:text-textClrDark mb-3">
              — The brand
            </p>
            <div className="w-full">
              <svg
                viewBox="0 0 400 90"
                className="w-full max-w-xl fill-bgClr dark:fill-bgClrDark font-bold"
              >
                <text
                  x="50%"
                  y="50%"
                  dy=".32em"
                  textAnchor="middle"
                  className="stroke-white stroke-2 text-[50px] tracking-[-3.2px] dark:animate-lineUpDark animate-lineUp"
                >
                  LOLLYTECH
                </text>
                <text
                  x="50%"
                  y="50%"
                  dy=".32em"
                  dx="2.8em"
                  textAnchor="middle"
                  className="stroke-white stroke-2 text-[50px] dark:animate-lineUpDark animate-lineUp"
                >
                  .
                </text>
              </svg>
            </div>
          </div>

          <div className="flex flex-col items-start lg:items-end gap-3 text-sm text-textClr dark:text-textClrDark">
            <div className="flex items-center gap-4">
              <motion.a
                whileHover={{ y: -3 }}
                href="https://github.com/LollyTim"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
                className="opacity-70 hover:opacity-100 hover:text-accentClr dark:hover:text-accentClrDark transition-colors"
              >
                <FaGithub size={20} />
              </motion.a>
              <motion.a
                whileHover={{ y: -3 }}
                href="https://www.linkedin.com/in/ololade-sanya-106990272/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="opacity-70 hover:opacity-100 hover:text-accentClr dark:hover:text-accentClrDark transition-colors"
              >
                <FaLinkedin size={20} />
              </motion.a>
              <motion.a
                whileHover={{ y: -3 }}
                href="https://twitter.com/Sanya_Ololade"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="X (Twitter)"
                className="opacity-70 hover:opacity-100 hover:text-accentClr dark:hover:text-accentClrDark transition-colors"
              >
                <FaXTwitter size={20} />
              </motion.a>
            </div>
            <a
              href="mailto:ololadetimileyin3@gmail.com"
              className="underline-offset-4 hover:underline opacity-80 hover:opacity-100"
            >
              ololadetimileyin3@gmail.com
            </a>
          </div>
        </div>

        <div className="mt-10 pt-4 border-t border-black/5 dark:border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 text-xs text-textClr dark:text-textClrDark opacity-70">
          <div className="flex items-center gap-2">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full rounded-full bg-green-500 opacity-75 animate-ping" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" />
            </span>
            <span>All systems online</span>
          </div>
          <p>© {year} Sanya Ololade · Built in Lagos 🇳🇬 · Shipping globally 🌍</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
